import Typography from "@mui/joy/Typography";
import { ClinicalEvent } from "../../../../models/clinical_event";
import { Answer, AnswerType } from "../../../../models/questionnaire";
import { groupFactsByAnswerType } from "../../../utils/question_answering";
import { ProofChip } from "./ProofChip";

interface DisplayAnswerFactsProps {
  readonly answerType: AnswerType;
  readonly answers: Answer[];
}

interface DisplayProofChipSetProps {
  readonly answerType: AnswerType;
  readonly events: ClinicalEvent[];
}

export function DisplayProofChipSet({ events, answerType }: DisplayProofChipSetProps) {
  const groupedFacts = groupFactsByAnswerType(events, answerType);
  return (
    <fieldset
      aria-labelledby="proof-chip-set"
      style={{
        border: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexWrap: "wrap",
        gap: "4px",
      }}
    >
      {Object.keys(groupedFacts).map((key, i) => (
        <ProofChip
          key={`${key}-${groupedFacts[key].length}`}
          name={key}
          eventSources={groupedFacts[key]}
        />
      ))}
    </fieldset>
  );
}

export function DisplayAnswerFacts({ answerType, answers }: DisplayAnswerFactsProps) {
  if (answers.length === 0) {
    return <Typography level="body-xs">-</Typography>;
  }
  const events = answers.flatMap((answer) => answer.events);
  if (events.length === 0) {
    return <Typography level="body-xs">-</Typography>;
  }

  if (answers.length === 1 && answers[0].text !== null) {
    return <Typography>{answers[0].text}</Typography>;
  }
  return <DisplayProofChipSet events={events} answerType={answerType} />;
}
